document.addEventListener('DOMContentLoaded', () => {
  const COMPARE_KEY = 'tdp_compare_items';
  const MAX_COMPARE = 4;
  let compareItems = JSON.parse(localStorage.getItem(COMPARE_KEY)) || [];

  const tray = document.getElementById('tdp-compare-tray');
  const trayItemsContainer = document.getElementById('tdp-compare-tray-items');
  const trayCountEl = document.getElementById('tdp-compare-count');
  const trayCompareBtn = document.getElementById('tdp-compare-tray-btn');
  const trayClearBtn = document.getElementById('tdp-compare-tray-clear');

  const dialogOverlay = document.getElementById('tdp-compare-dialog-overlay');
  const dialogCloseBtn = document.getElementById('tdp-compare-dialog-close');
  const dialogTableBody = document.getElementById('tdp-compare-table-body');

  function saveItems() {
    localStorage.setItem(COMPARE_KEY, JSON.stringify(compareItems));
    updateTrayUI();
    updateCompareButtons();
  }

  function toggleItem(item) {
    const existsIndex = compareItems.findIndex(i => i.handle === item.handle);
    if (existsIndex > -1) {
      compareItems.splice(existsIndex, 1);
    } else {
      if (compareItems.length >= MAX_COMPARE) {
        alert(`You can only compare up to ${MAX_COMPARE} items.`);
        return;
      }
      compareItems.push(item);
    }
    saveItems();
  }

  function removeItem(handle) {
    compareItems = compareItems.filter(i => i.handle !== handle);
    saveItems();
  }

  function clearItems() {
    compareItems = [];
    saveItems();
    if (dialogOverlay.classList.contains('is-active')) {
      dialogOverlay.classList.remove('is-active');
    }
  }

  function updateCompareButtons() {
    document.querySelectorAll('.tdp-compare-btn').forEach(btn => {
      const handle = btn.getAttribute('data-product-handle');
      if (compareItems.find(i => i.handle === handle)) {
        btn.classList.add('is-active');
      } else {
        btn.classList.remove('is-active');
      }
    });
  }

  function updateTrayUI() {
    if (!tray) return;

    if (compareItems.length > 0) {
      tray.classList.add('is-active');
    } else {
      tray.classList.remove('is-active');
    }

    trayItemsContainer.innerHTML = '';
    compareItems.forEach(item => {
      const div = document.createElement('div');
      div.className = 'tdp-compare-tray-item';
      
      const img = document.createElement('img');
      img.src = item.image || '';
      img.alt = item.title;
      
      const removeBtn = document.createElement('button');
      removeBtn.className = 'tdp-compare-tray-item-remove';
      removeBtn.setAttribute('aria-label', `Remove ${item.title}`);
      removeBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>';
      
      removeBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        removeItem(item.handle);
      });

      div.appendChild(img);
      div.appendChild(removeBtn);
      trayItemsContainer.appendChild(div);
    });

    for (let i = compareItems.length; i < MAX_COMPARE; i++) {
      const div = document.createElement('div');
      div.className = 'tdp-compare-tray-placeholder';
      trayItemsContainer.appendChild(div);
    }

    trayCountEl.textContent = compareItems.length;
    trayCompareBtn.disabled = compareItems.length < 2;
  }

  function formatMoney(cents) {
    if (!cents) return '';
    return '₹' + (cents / 100).toLocaleString('en-IN');
  }

  function getSizedImageUrl(src, size) {
    if (!src) return '';
    if (src.includes(`_${size}x`)) return src;
    return src.includes('?') ? `${src}&width=${size}` : `${src}?width=${size}`;
  }

  async function openCompareDialog() {
    if (compareItems.length < 2) return;
    
    dialogOverlay.classList.add('is-active');
    document.documentElement.style.setProperty('--compare-count', compareItems.length);
    dialogTableBody.innerHTML = '<tr><td colspan="' + (compareItems.length + 1) + '" style="text-align:center;padding:40px;">Loading data...</td></tr>';

    try {
      // Fetch full details for all compared items
      const fetchPromises = compareItems.map(item => fetch(`/products/${item.handle}.js`).then(r => r.json()));
      const productsData = await Promise.all(fetchPromises);

      renderDialogTable(productsData);
    } catch (e) {
      console.error('Failed to fetch compare data', e);
      dialogTableBody.innerHTML = '<tr><td colspan="' + (compareItems.length + 1) + '" style="text-align:center;padding:40px;">Failed to load comparison data.</td></tr>';
    }
  }

  function renderDialogTable(products) {
    let html = '';

    // Header Row (Images & Basic Info)
    html += '<tr><th>Product</th>';
    products.forEach((p, index) => {
      const itemPrice = p.price;
      const displayPrice = itemPrice ? formatMoney(itemPrice) : compareItems[index].price;
      const rawImgUrl = (p.images && p.images[0]) ? p.images[0] : compareItems[index].image;
      const imgUrl = getSizedImageUrl(rawImgUrl, 400);
      
      html += `
        <td>
          <div class="tdp-compare-item-header">
            <button class="tdp-compare-item-remove" data-handle="${p.handle}" aria-label="Remove">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
            </button>
            <div class="tdp-compare-item-image">
              <img src="${imgUrl}" alt="${p.title}" />
            </div>
            <p class="tdp-qv-vendor" style="margin-bottom:4px;">${p.vendor}</p>
            <h3 class="tdp-compare-item-title">${p.title}</h3>
            <p class="tdp-compare-item-price">${displayPrice}</p>
            <button class="tdp-compare-item-add tdp-js-add-to-cart" data-variant-id="${p.variants[0].id}" ${!p.available ? 'disabled' : ''}>
              ${p.available ? 'Add to Bag' : 'Out of Stock'}
            </button>
          </div>
        </td>
      `;
    });
    html += '</tr>';

    // Description Row
    html += '<tr><th>Description</th>';
    products.forEach(p => {
      // Strip HTML tags roughly for compare view, or show snippet
      const descSnippet = p.description.replace(/<[^>]*>?/gm, '').substring(0, 150) + '...';
      html += `<td><div class="tdp-compare-text">${descSnippet}</div></td>`;
    });
    html += '</tr>';

    // Options mapping dynamically
    // Find all unique option names across compared products
    let allOptionNames = new Set();
    products.forEach(p => {
       p.options.forEach(opt => {
          if (opt.name !== 'Title') {
             allOptionNames.add(opt.name);
          }
       });
    });

    Array.from(allOptionNames).forEach(optName => {
       html += `<tr><th>${optName}</th>`;
       products.forEach(p => {
          let optValue = '-';
          const optIndex = p.options.findIndex(o => o.name === optName);
          if (optIndex > -1) {
             optValue = p.options[optIndex].values.join(', ');
          }
          html += `<td><div class="tdp-compare-text">${optValue}</div></td>`;
       });
       html += '</tr>';
    });

    dialogTableBody.innerHTML = html;

    // Attach events for dynamically created buttons
    dialogTableBody.querySelectorAll('.tdp-compare-item-remove').forEach(btn => {
      btn.addEventListener('click', () => {
        removeItem(btn.getAttribute('data-handle'));
        if (compareItems.length < 2) {
           dialogOverlay.classList.remove('is-active');
        } else {
           openCompareDialog(); // Re-render
        }
      });
    });

    dialogTableBody.querySelectorAll('.tdp-js-add-to-cart').forEach(btn => {
      btn.addEventListener('click', () => {
        const variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;
        
        btn.disabled = true;
        btn.textContent = 'Adding...';

        fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
           method: 'POST',
           headers: { 'Content-Type': 'application/json' },
           body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
        .then(res => res.json())
        .then(() => {
           window.location.reload();
        })
        .catch(err => {
           console.error(err);
           btn.disabled = false;
           btn.textContent = 'Add to Bag';
        });
      });
    });
  }

  // Event Listeners
  document.body.addEventListener('click', (e) => {
    const btn = e.target.closest('.tdp-compare-btn');
    if (btn) {
      e.preventDefault();
      const item = {
        handle: btn.getAttribute('data-product-handle'),
        title: btn.getAttribute('data-product-title'),
        vendor: btn.getAttribute('data-product-vendor'),
        price: btn.getAttribute('data-product-price'),
        image: btn.getAttribute('data-product-image')
      };
      toggleItem(item);
    }
  });

  if (trayCompareBtn) trayCompareBtn.addEventListener('click', openCompareDialog);
  if (trayClearBtn) trayClearBtn.addEventListener('click', clearItems);
  
  if (dialogCloseBtn) {
    dialogCloseBtn.addEventListener('click', () => {
      dialogOverlay.classList.remove('is-active');
    });
  }

  if (dialogOverlay) {
    dialogOverlay.addEventListener('click', (e) => {
      if (e.target === dialogOverlay) {
        dialogOverlay.classList.remove('is-active');
      }
    });
  }

  // Initialize
  updateTrayUI();
  updateCompareButtons();
});
